import { useQuery } from "react-query";
import { useAppSelector } from "src/redux/store";
import {
  EntityOptionsSource,
  getRecordEntityOptions,
} from "src/utils/api/dashboard";

export const useRecordEntityOptions = (
  source: EntityOptionsSource,
  filters: Record<string, any>,
  enabled = true
) => {
  const userId = useAppSelector((state) => state.root.user.data.userId);
  const { data, isFetching, isError } = useQuery(
    ["recordEntityOptions", userId, source, filters],
    () => getRecordEntityOptions(source, filters),
    { staleTime: 60 * 1000, enabled: enabled && !!userId }
  );
  return { entityInfo: data?.data?.rows ?? [], isFetching, isError };
};
